/** Pose frame of Omni. Scan rays in this frame share the map pin. */
export const POSE_FRAME_BASE_LINK = 'base_link'
/** Scan frame published today on every Autonomics platform. */
export const SCAN_FRAME_REAR_AXLE = 'rear_axle'

export type ScanPoleOffsetM = { x: number; y: number }

const ZERO: ScanPoleOffsetM = { x: 0, y: 0 }

/**
 * Shift of the scan pole in the pose frame, +x forward.
 *
 * Omni pose is base_link. While the scan is still rear_axle (or the frame is
 * missing), the pole sits wheel_base/2 behind the pin. A scan already in
 * base_link needs no shift. Sweeper and Combo share rear_axle for both.
 * An unknown frame is drawn from the pose; the lidar lever arm is not guessed.
 */
export function scanPoleOffsetMeters(params: {
  poseFrame?: string | null
  wheelBaseM?: number | null
  scanFrameId?: string | null
}): ScanPoleOffsetM {
  const pose = String(params.poseFrame || '').trim()
  const scan = String(params.scanFrameId || '').trim()
  if (scan && scan !== SCAN_FRAME_REAR_AXLE && scan !== POSE_FRAME_BASE_LINK) {
    return ZERO
  }
  if (scan && pose && scan === pose) {
    return ZERO
  }
  const wheel = params.wheelBaseM
  if (
    pose === POSE_FRAME_BASE_LINK &&
    (scan === '' || scan === SCAN_FRAME_REAR_AXLE) &&
    typeof wheel === 'number' &&
    Number.isFinite(wheel) &&
    wheel > 0
  ) {
    return { x: -wheel / 2, y: 0 }
  }
  return ZERO
}

export function scanFrameIdFromPayload(scan: { header?: { frame_id?: string | null } | null } | null | undefined): string {
  return String(scan?.header?.frame_id || '').trim()
}
